import { render, staticRenderFns } from "./ProfileRealtime.view.vue?vue&type=template&id=1cb501ec&"
import script from "./ProfileRealtime.view.vue?vue&type=script&lang=js&"
export * from "./ProfileRealtime.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports